const onceMap = {};
export const isAndroid =
  navigator.userAgent.indexOf('Android') > -1 ||
  navigator.userAgent.indexOf('Adr') > -1;

export const isiOS = !!navigator.userAgent.match(
  /\(i[^;]+;( U;)? CPU.+Mac OS X/
);

const handler = {};

export const bridgeUtils = {
  dealParam(query) {
    const params = {};
    /*如果没用传参数，尝试从url上获取*/
    query = query || window.location.hash || window.location.search;
    if (query) {
      /*如果有参数，把参数转为Object*/
      query = decodeURI(
        query.indexOf('?') === 0 ? query.substr(1) : query
      ); /*去除？*/
      const str = query.split('&');
      str.forEach(it => {
        const s = it.split('=');
        params[s[0]] = s[1];
      });
    }
    return params;
  },
  //生成回调方法，并挂载到window对象上
  addCallBack(resolve, reject, funcName, once) {
    const execFuncName = () =>
      `${funcName}_${Date.now()}_${Math.ceil(Math.random() * 100000)}`;
    // const execFuncName = () => funcName;
    //通过循环防止出现相同的回调方法名
    let callBack = execFuncName();
    while (window[callBack]) {
      //如果这个回调方法名已经存在，就会重新生成方法名
      callBack = execFuncName();
    }

    // 该回调方法要是30秒内还未执行，就直接标注为超时了
    const timer = setTimeout(() => {
      // window[callBack](false, { data: '执行超时' });
    }, 30000);

    window[callBack] = (isSuccess, data) => {
      // console.log('isSuccess', isSuccess, data); // eslint-disable-line no-console
      clearTimeout(timer); //方法执行后清除定时器
      once && delete onceMap[funcName]; //移除方法执行中的标记
      if (isSuccess) {
        //如果有返回，触发完成状态
        resolve(data);
      } else {
        //否则触发失败状态
        // reject(data);
      }
      delete window[callBack]; /*移除回调函数*/
    };

    return callBack;
  },
  //处理参数，将参数转为URL形式传递给原生
  beforeOpenWindow(data = {}) {
    let { url, params } = data;
    if (params) {
      const p = [];
      Object.keys(params).forEach(function(key) {
        p.push(key + '=' + params[key]);
      });
      if (p.length > 0) {
        url.indexOf('?') > 0
          ? (url += '&' + p.join('&'))
          : (url += '?' + p.join('&'));
      }
    }
    delete data.params;
    data.url = url;
  },
  execBridge(funcName, data, once, getPromise) {
    if (once && onceMap[funcName]) {
      //如果方法仅存在一个实例并且正在执行中
      return onceMap[funcName];
    } else {
      const promise = getPromise();
      if (once) {
        onceMap[funcName] = promise;
      }
      return promise;
    }
  },
};

if (isAndroid) {
  handler.callBridge = (funcName, data) => {
    return new Promise((resolve, reject) => {
      window[funcName] = (isSuccess, data) => {
        console.log(data);
        data = JSON.parse(data);
        if (isSuccess === 'true') {
          resolve(data);
        } else {
          reject(data);
        }
      };
      // window.android&&window.android[funcName] &&
      //   window.android[funcName](funcName, JSON.stringify(data));
      try {
        window.android[funcName](funcName, JSON.stringify(data));
      } catch (error) {
        resolve('jsBridge funcName is undefined')
      }

        
    });
  };

  // handler.callBridge = (funcName, data = {}, once = false) =>
  //   bridgeUtils.execBridge(
  //     funcName,
  //     data,
  //     once,
  //     () =>
  //       new Promise((resolve, reject) => {
  //         if (funcName === 'openWindow') {
  //           bridgeUtils.beforeOpenWindow(data);
  //         }
  //         // 如果是执行数据存储，需要对值进行预转义
  //         if (funcName === 'setData' && data.value) {
  //           data.value = data.value.replace(/"/g, '\\"');
  //         }
  //         const cbName = bridgeUtils.addCallBack(
  //             resolve,
  //             reject,
  //             funcName,
  //             once
  //           ),
  //           _data = data ? JSON.stringify(data) : '';
  //
  //         cbName;
  //
  //         window.android[funcName] && window.android[funcName](funcName, _data);
  //
  //         // window.WebViewJavascriptBridge.callHandler(funcName, data, res => {
  //         //   if (res.isSuccess === 'true') {
  //         //     console.log('android cb----->', res.data); // eslint-disable-line no-console
  //         //     resolve(JSON.parse(res.data));
  //         //   } else {
  //         //     reject(null);
  //         //   }
  //         // });
  //       })
  //   );
} else if (isiOS) {
  handler.callBridge = (funcName, data = {}, once = false) =>
    bridgeUtils.execBridge(
      funcName,
      data,
      once,
      () =>
        new Promise((resolve, reject) => {
          data.callBack = bridgeUtils.addCallBack(
            resolve,
            reject,
            funcName,
            once
          );

          try {
            window.webkit.messageHandlers[funcName].postMessage(data);
          } catch (error) {
            resolve('jsBridge funcName is undefined')
          }


        })
    );
}else {
  handler.callBridge = () => {
    return new Promise((resolve, reject) => {
      resolve('jsBridge funcName is undefined')
    })
  }
}

/**
 * 返回上一页
 * @returns {*}
 */
handler.goBack = function(params = {}) {
  return handler.callBridge('nativeGoBack', params);
};

/**
 *向native传递信息
 * @returns {*}
 */
handler.sendMessageToNative = function(params = {}) {
  return handler.callBridge('sendMessageToNative', params);
};

/**
 * 获取用户信息
 * @returns {*}
 */
handler.getUserInfo = function() {
  return handler.callBridge('getUserInfo');
};

/**
 * 跳转指定页
 * @param url {string}
 */
handler.jumpPage = function(url = '') {
  return handler.callBridge('openAppointPage', { pageString: url });
};

/**
 * 顶部显示隐藏
 * @param hidden{string} // 0 隐藏 1 显示
 */
handler.isShowOrHiddenNavBar = function(hidden = '0') {
  console.log();
  return handler.callBridge('isShowOrHiddenNavBar', { isShow: hidden });
};

// 设备信息
handler.getDeviceInfo = function() {
  // return statusBarH
  return handler.callBridge('getDeviceInfo');
};

// 导航栏颜色
// 1 浅色 0黑色
handler.setStatusBarColor = function(isLight  = '1') {
  return handler.callBridge('setStatusBarColor', { isLight });
};

/**
 * 显示导航栏右上按钮
 * @param payload 0 代表隐藏,0为字符串  rightBtnType 可以根据需要填写
 * @returns {*}
 */
handler.isShowOrHiddenRightBtn = function(
  payload = { isShow: '0', rightBtnType: '0' }
) {
  console.log('调用显示导航栏右上按钮接口，isShow=', payload.isShow); // eslint-disable-line no-console
  return handler.callBridge('isShowOrHiddenRightBtn', payload);
};

/**
 * 分享
 * @param payload
 * @returns {*}
 */
handler.shareMessage = function(payload) {
  return handler.callBridge('shareMessage', payload);
};

export default handler;
